module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-form-container"
  }, [_c('form', {
    staticClass: "register-form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.register.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "name-fields"
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.firstNameError()
    }
  }, [_c('label', {
    attrs: {
      "for": "register-first-name"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "register-first-name",
      "required": ""
    },
    on: {
      "blur": function($event) {
        return _vm.validateName('firstName')
      }
    },
    model: {
      value: (_vm.newUser.firstName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "firstName", $$v)
      },
      expression: "newUser.firstName"
    }
  }), _vm._v(" "), (_vm.firstNameError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.lastNameError()
    }
  }, [_c('label', {
    attrs: {
      "for": "register-last-name"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "register-last-name",
      "required": ""
    },
    on: {
      "blur": function($event) {
        return _vm.validateName('lastName')
      }
    },
    model: {
      value: (_vm.newUser.lastName),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "lastName", $$v)
      },
      expression: "newUser.lastName"
    }
  }), _vm._v(" "), (_vm.lastNameError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.emailError()
    }
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "register-email",
      "type": "email",
      "required": ""
    },
    on: {
      "blur": _vm.validateEmail
    },
    model: {
      value: (_vm.newUser.email),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "email", $$v)
      },
      expression: "newUser.email"
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.passwordError()
    }
  }, [_c('label', {
    attrs: {
      "for": "register-password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "register-password",
      "type": "password",
      "required": ""
    },
    on: {
      "input": _vm.validatePassword
    },
    model: {
      value: (_vm.newUser.password),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "password", $$v)
      },
      expression: "newUser.password"
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 1), _vm._v(" "), (_vm.newUser.password && !_vm.passwordValidation.isValid) ? _c('div', {
    staticClass: "password-requirements"
  }, [_c('div', {
    staticClass: "requirement-item",
    class: {
      'requirement-met': _vm.passwordValidation.requirements.minLength
    }
  }, [_c('md-icon', {
    staticClass: "requirement-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', [_vm._v("At least 8 characters")])], 1), _vm._v(" "), _c('div', {
    staticClass: "requirement-item",
    class: {
      'requirement-met': _vm.passwordValidation.requirements.hasUpperCase
    }
  }, [_c('md-icon', {
    staticClass: "requirement-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', [_vm._v("One uppercase letter")])], 1), _vm._v(" "), _c('div', {
    staticClass: "requirement-item",
    class: {
      'requirement-met': _vm.passwordValidation.requirements.hasLowerCase
    }
  }, [_c('md-icon', {
    staticClass: "requirement-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', [_vm._v("One lowercase letter")])], 1), _vm._v(" "), _c('div', {
    staticClass: "requirement-item",
    class: {
      'requirement-met': _vm.passwordValidation.requirements.hasNumbers
    }
  }, [_c('md-icon', {
    staticClass: "requirement-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', [_vm._v("One number")])], 1), _vm._v(" "), _c('div', {
    staticClass: "requirement-item",
    class: {
      'requirement-met': _vm.passwordValidation.requirements.hasSpecialChar
    }
  }, [_c('md-icon', {
    staticClass: "requirement-icon"
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('span', [_vm._v("One special character")])], 1)]) : _vm._e(), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.confirmPasswordError()
    }
  }, [_c('label', {
    attrs: {
      "for": "register-confirm-password"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "id": "register-confirm-password",
      "type": "password",
      "required": ""
    },
    on: {
      "input": _vm.validatePasswordMatch
    },
    model: {
      value: (_vm.newUser.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.newUser, "confirmPassword", $$v)
      },
      expression: "newUser.confirmPassword"
    }
  }), _vm._v(" "), (_vm.confirmPasswordError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("Passwords do not match")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "consent-row",
    attrs: {
      "for": "register-marketing-consent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketingConsent),
      expression: "marketingConsent"
    }],
    staticClass: "consent-box",
    attrs: {
      "id": "register-marketing-consent",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.marketingConsent) ? _vm._i(_vm.marketingConsent, null) > -1 : (_vm.marketingConsent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.marketingConsent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.marketingConsent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.marketingConsent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.marketingConsent = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "consent-copy"
  }, [_vm._v("\n                " + _vm._s(_vm.consentText) + "\n                "), _c('span', {
    staticClass: "consent-sub"
  }, [_vm._v(_vm._s(_vm.consentSubtext))])])]), _vm._v(" "), (_vm.generalErrorMessage) ? _c('p', {
    staticClass: "register-error",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.generalErrorMessage))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary register-button",
    attrs: {
      "disabled": _vm.loading || !_vm.isFormValid
    },
    on: {
      "click": _vm.register
    }
  }, [(_vm.loading) ? _c('md-spinner', {
    staticClass: "md-accent",
    attrs: {
      "md-size": 20
    }
  }) : _c('span', [_vm._v("Create Account")])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-link"
  }, [_c('span', [_vm._v("Already have an account?")]), _vm._v(" "), _c('md-button', {
    staticClass: "signup-link",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.toggleRegister
    }
  }, [_vm._v("\n                Sign in\n            ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df2e4fb8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/register-form.vue
// module id = 1292
// module chunks = 21